/**
 * Whether an employee can get into the portal, and if not, why.
 *
 * Related to but not the same as {@link UserStatus}, which mixes the state of a
 * login with the role it carries and exists to filter the member portal's own
 * contact list. This says only whether there is a way in.
 */
export enum EmployeeAccess {
    None = 'EMPLOYEE_ACCESS_NONE',
    Invited = 'EMPLOYEE_ACCESS_INVITED',
    Locked = 'EMPLOYEE_ACCESS_LOCKED',
    Disabled = 'EMPLOYEE_ACCESS_DISABLED',
    Active = 'EMPLOYEE_ACCESS_ACTIVE',
}

const translationObject: { [Key in EmployeeAccess]: string } = {
    [EmployeeAccess.None]: 'app.employeeAccess.none',
    [EmployeeAccess.Invited]: 'app.employeeAccess.invited',
    [EmployeeAccess.Locked]: 'app.employeeAccess.locked',
    [EmployeeAccess.Disabled]: 'app.employeeAccess.disabled',
    [EmployeeAccess.Active]: 'app.employeeAccess.active',
};

export const getEmployeeAccessTranslationId = (access: EmployeeAccess): string => translationObject[access] || '';
